import { BackgroundAction } from '../BackgroundAction'
import { expensesBackgroundAction } from './api'

export const ExportBackgroundAction = new BackgroundAction({
  api: expensesBackgroundAction,
})

export const DownloadBackgroundAction = new BackgroundAction({
  api: expensesBackgroundAction,
})

export const AccountingExportBackgroundAction = new BackgroundAction({
  api: expensesBackgroundAction,
})
